import * as React from "react"
const SavedProducts = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke={props.color ? props.color : "#202327"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.667 3.333v13.333M4.167 3.333v13.333M12.5 3.333v13.333M6.667 15V5c0-.786 0-1.179.244-1.423s.637-.244 1.422-.244c.786 0 1.179 0 1.423.244S10 4.214 10 5v10c0 .785 0 1.178-.244 1.422s-.637.244-1.423.244c-.785 0-1.178 0-1.422-.244s-.244-.637-.244-1.422ZM15 15V5c0-.786 0-1.179.244-1.423s.637-.244 1.423-.244c.785 0 1.178 0 1.422.244s.244.637.244 1.423v10c0 .785 0 1.178-.244 1.422s-.637.244-1.422.244c-.786 0-1.179 0-1.423-.244S15 15.785 15 15Z"
    />
  </svg>
)
export default SavedProducts
